import {MenuDocument} from "../editor/MenuDocumentModel";
import {AxiosResponse} from "axios";
import GetPdfTemplate from "./GetPdfTemplate";
import {GeneratedPdfResponse, generatePdf, GeneratePdfRequest} from "lib/api/pdfGenerator";

export function generateWineMenuPdf(document: MenuDocument): Promise<AxiosResponse<GeneratedPdfResponse>> {
    return generatePdf(toPdfRequestData(document));
}

export function toPdfRequestData(document: MenuDocument): GeneratePdfRequest {
    const template = GetPdfTemplate();
    return {
        format: document.format,
        printMode: document.printMode,
        template: template,
        data: document
    };
}